import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import moment from 'moment'

import Portico from '@ordernext/networking-stadium/portico'

import useInterval from 'hooks/useInterval'
import Loader from 'components/Loader'
import { updateTokens } from 'utils/auth'

const ONE_MINUTE = 60000
const ONE_HOUR = ONE_MINUTE * 60

const DeviceLogin = ({ history }) => {
  const [loading, setLoading] = useState(true)

  const onSuccess = response => {
    updateTokens(response)
    setTimeout(() => {
      setLoading(false)
      history.replace('revenueCenters')
    }, 1000)
  }

  const onFailure = () => {
    history.replace('/login')
    setLoading(false)
  }

  const login = () => {
    const deviceId = window.localStorage.device_id
    const appKey = process.env.REACT_APP_OIDC_CLIENT_ID
    const organizationName = process.env.REACT_APP_ORG

    if (moment(localStorage.getItem('expiresAt')) > moment()) {
      setLoading(false)
      history.replace('/')
      return
    }

    Portico.deviceLogin(deviceId, appKey, organizationName)
      .then(onSuccess)
      .catch(onFailure)
  }

  useEffect(() => login(), [])

  const checkTokenExpireTime = () => {
    if (!localStorage.getItem('expiresAt')) return null

    const expiresAt = moment(localStorage.getItem('expiresAt'))
    const tokenMillisecondsRemaining = expiresAt.diff(moment())

    if (tokenMillisecondsRemaining < ONE_HOUR) {
      const deviceId = window.localStorage.device_id
      const appKey = process.env.REACT_APP_OIDC_CLIENT_ID
      const organizationName = process.env.REACT_APP_ORG
      Portico.deviceLogin(deviceId, appKey, organizationName)
        .then(updateTokens)
        .catch(onFailure)
    }
  }

  useInterval(() => {
    checkTokenExpireTime()
  }, ONE_MINUTE)

  return loading ? <Loader /> : null
}

DeviceLogin.propTypes = {
  history: PropTypes.object,
}

export default withRouter(DeviceLogin)
